// import { getExchangeMultiplier } from 'services/exchanges';

import { getExchangeMultiplier } from "../../../../exchanges";

function formatCompactMarketData({
  exchange,
  instrumentToken,
  ltp,
  change,
  ltt,
  lowDpr,
  highDpr,
  currentOpenInterest,
  initialOpenInterest,
  bidPrice,
  askPrice,
  precision,
}) {
  const divisor = exchange === 3 || exchange === 19 ? Math.pow(10, precision) : getExchangeMultiplier(exchange);
  const absoluteChange = change / divisor;
  const formattedLtp = ltp / divisor;
  const pc = (absoluteChange * 100) / (formattedLtp - absoluteChange);
  const percentChange = Number.isFinite(pc) ? pc : 0;
  return {
    exchange,
    instrumentToken,
    ltp: formattedLtp,
    absoluteChange,
    percentChange,
    ltt,
    lowDpr: lowDpr / divisor,
    highDpr: highDpr / divisor,
    currentOpenInterest,
    initialOpenInterest,
    bidPrice: bidPrice / divisor,
    askPrice: askPrice / divisor,
    precision,
  }
}

export default formatCompactMarketData;
